export const fromEntries =
    typeof Object.fromEntries === "function"
        ? Object.fromEntries
        : (
              entries: Iterable<readonly [PropertyKey, any]>,
          ): { [k: string]: any } =>
              Array.from(entries).reduce(
                  (accumulator, [key, value]) =>
                      Object.assign(accumulator, { [key]: value }),
                  {},
              );
